<template>
    <v-dialog v-model="model" max-width="600px" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
            <div class="pl-4 pr-3 py-3 primary">
                <div class="d-flex align-center justify-space-between">
                    <div>
                        <v-layout align-center>
                            <v-icon size="12px" color="white" class="mr-2">fas fa-lock fa-fw</v-icon> 
                            <div class="white--text font-weight-medium caption">EDIT PASSWORD</div> 
                        </v-layout>
                    </div>
                    <div>
                        <v-btn small text fab @click="$emit('cancel')" class="my-0">
                            <v-icon small color="white">fa-times</v-icon> 
                        </v-btn>
                    </div>
                </div>
            </div>

            <v-card-text class="pt-8">
                <div class="px-4 black--text body-1 text-center">
                    <v-text-field
                        v-model="previous"
                        label="Actual password"
                        outlined dense
                        maxlength="50"
                        @keydown.enter="validate"
                        type="password"
                        :disabled="sending">
                        <template v-slot:prepend>
                            <v-icon color="info" class="mt-1 mr-1" small>fa-lock fa-fw</v-icon>
                        </template>
                    </v-text-field>
                </div>

                <div class="px-4 black--text body-1 text-center">
                    <v-text-field
                        v-model="info.password"
                        label="New password"
                        maxlength="50"
                        outlined dense
                        @keydown.enter="validate"
                        type="password"
                        :disabled="sending">
                        <template v-slot:prepend>
                            <v-icon color="accent" class="mt-1 mr-1" small>fa-lock fa-fw</v-icon>
                        </template>
                    </v-text-field>
                </div>

                <div class="px-4 black--text body-1 text-center">
                    <v-text-field
                        v-model="confirm"
                        label="Confirm new password"
                        maxlength="50"
                        outlined dense
                        @keydown.enter="validate"
                        type="password"
                        :disabled="sending">
                        <template v-slot:prepend>
                            <v-icon color="accent" class="mt-1 mr-1" small>fa-lock fa-fw</v-icon>
                        </template>
                    </v-text-field>
                </div>
            </v-card-text>

            <div class="d-flex justify-end align-center px-4 pb-4" :class="(sending) ? 'pa-1' : 'pa-4'">
                <v-btn text large class="info--text text--darken-1" @click="$emit('cancel')" v-if="!sending">Cancel</v-btn>
                <v-btn text large class="accent" @click="validate" v-if="!sending">Save</v-btn>
                <SendingLoader v-if="sending" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import Personal from '@/firebase/personal'

export default {
    data: () => ({
        sending: false,
        previous: '',
        confirm: '',
        info: {
            password: ''
        }
    }),
    props: ['model'],
    watch: {
        model(val) {
            if (val == false) {
                this.sending = false;
                this.previous = '';
                this.confirm = '';
                this.info.password = '';
            }
        }
    },
    methods: {
        validate() {
            if (this.validateIsEmpty(this.info.password) || this.validateIsEmpty(this.previous) || this.validateIsEmpty(this.confirm)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Es necesario llenar todos los campos.'});
                return;
            }

            if (this.info.password != this.confirm) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Las contraseñas no coinciden.'});
                return;
            }

            if (this.info.password.length < 6) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Al menos se requiere 6 caracteres.'});
                return;
            }

            this.save();
        },
        save() {
            this.sending = true;

            Personal.updatePassword(this.user.email, this.previous, this.info.password)
                    .then(response => {
                        if (response === true) {
                            this.$emit('changed');
                            this.$store.dispatch('setSnack', {kind:'success', text:'Contraseña modificada.'});
                        } else if (response.code === 'auth/wrong-password') {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Contraseña actual incorrecta.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Ha ocurrido un error.'});
                        }
                        this.sending = false;
                    });
        }
    }
}
</script>

